import { EventBus } from '@/lib/event-bus';

export const $confirm = (options) => EventBus.$emit('show-confirm', options);
